/**
  Recipe Handler
  Handles nutrition facts analytics, print functionality, and share tracking
 */

class RecipeHandler {
  constructor() {
    this.listeners = [];
    this.init();
  }

  init() {
    this.cleanup();
    this.initNutritionFactsAnalytics();
    this.initPrintButton();
    this.initShareButtons();
  }

  cleanup() {
    // Remove all existing event listeners to prevent memory leaks
    this.listeners.forEach(({ element, type, handler }) => {
      element.removeEventListener(type, handler);
    });
    this.listeners = [];
  }

  addListener(element, type, handler) {
    element.addEventListener(type, handler);
    this.listeners.push({ element, type, handler });
  }

  initNutritionFactsAnalytics() {
    // Track analytics when nutrition facts are opened (using native details element)
    const nutritionDetails = document.querySelectorAll('.article-content__nutrition-facts details');

    nutritionDetails.forEach((details) => {
      const handler = () => {
        if (details.open && typeof dataLayer !== 'undefined') {
          dataLayer.push({ event: 'nutrition_facts_open' });
        }
      };
      this.addListener(details, 'toggle', handler);
    });
  }

  initPrintButton() {
    const printButtons = document.querySelectorAll('.social-share__print');

    printButtons.forEach((button) => {
      const handler = (e) => {
        e.preventDefault();
        window.print();
      };
      this.addListener(button, 'click', handler);
    });
  }

  initShareButtons() {
    const shareLinks = document.querySelectorAll('.social-share__link');

    shareLinks.forEach((link) => {
      const handler = () => {
        // Let external links work normally, but track them
        const platform = this.getPlatformFromLink(link);
        if (platform && typeof dataLayer !== 'undefined') {
          dataLayer.push({
            event: 'recipe_share',
            platform,
          });
        }
      };
      this.addListener(link, 'click', handler);
    });
  }

  getPlatformFromLink(link) {
    // Use classList values() iterator to find platform class
    const platformClass = [...link.classList].find((c) => c.includes('gtm_recipe_'));
    return platformClass ? platformClass.replace('gtm_recipe_', '') : null;
  }

  refresh() {
    this.init();
  }

  destroy() {
    this.cleanup();
  }
}

function initRecipeHandler() {
  if (typeof window.recipeHandler === 'undefined') {
    window.recipeHandler = new RecipeHandler();
  } else {
    window.recipeHandler.refresh();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRecipeHandler);
} else {
  initRecipeHandler();
}

document.addEventListener('shopify:section:load', initRecipeHandler);
document.addEventListener('shopify:section:reorder', initRecipeHandler);

// Export for module usage if needed
if (typeof module !== 'undefined' && module.exports) {
  module.exports = RecipeHandler;
}
